export default function calculateSegments(
  { minValue, maxValue, errorLower, errorUpper, warningLower, warningUpper, warningEnabled, errorEnabled },
  colors = {},
) {
  const alarmColor = colors.alarm || '#ef9a9a';
  const warningColor = colors.warning || '#ffcc80';
  const normalColor = colors.normal || '#a5d6a7';

  const range = maxValue - minValue;
  if (range === 0) {
    return [{ start: minValue, end: maxValue, color: normalColor, label: 'normal' }];
  }

  const segments = [];

  if (errorEnabled) {
    if (minValue < errorLower) {
      segments.push({ start: minValue, end: errorLower, color: alarmColor, label: 'alarm-low' });
    }

    if (warningEnabled) {
      if (errorLower < warningLower) {
        segments.push({ start: errorLower, end: warningLower, color: warningColor, label: 'warning-low' });
      }
      segments.push({ start: warningLower, end: warningUpper, color: normalColor, label: 'normal' });
      if (warningUpper < errorUpper) {
        segments.push({ start: warningUpper, end: errorUpper, color: warningColor, label: 'warning-high' });
      }
    } else {
      segments.push({ start: errorLower, end: errorUpper, color: normalColor, label: 'normal' });
    }

    if (errorUpper < maxValue) {
      segments.push({ start: errorUpper, end: maxValue, color: alarmColor, label: 'alarm-high' });
    }
  } else if (warningEnabled) {
    if (minValue < warningLower) {
      segments.push({ start: minValue, end: warningLower, color: warningColor, label: 'warning-low' });
    }
    segments.push({ start: warningLower, end: warningUpper, color: normalColor, label: 'normal' });
    if (warningUpper < maxValue) {
      segments.push({ start: warningUpper, end: maxValue, color: warningColor, label: 'warning-high' });
    }
  } else {
    segments.push({ start: minValue, end: maxValue, color: normalColor, label: 'normal' });
  }

  return segments;
}